import {Section} from "../../@types/privacyPolicySectionResources.tsx";
import {Language} from "../../@types/generics.tsx";

export const FraudGuidelinesSectionsConfig: Section[] = [
    {
        paragraphs: [
            {
                text: 'fraud_inform_paragraph_1',
                languageToShow: [Language.LT, Language.EN]
            }
        ],
        languageToShow: [Language.LT, Language.EN]
    },
    {
        heading: 'fraud_effect_heading',
        paragraphs: [
            {
                text: 'fraud_effect_paragraph_1',
                languageToShow: [Language.LT, Language.EN]
            },
            {
                text: 'fraud_effect_paragraph_2',
                list: [
                    {
                        text: 'fraud_effect_paragraph_2_list_1',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'fraud_effect_paragraph_2_list_2',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'fraud_effect_paragraph_2_list_3',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'fraud_effect_paragraph_2_list_4',
                        languageToShow: [Language.LT, Language.EN]
                    }
                ],
                languageToShow: [Language.LT, Language.EN]
            },
        ],
        languageToShow: [Language.LT, Language.EN]
    },
    {
        heading: 'fraud_preventive_measures_heading',
        paragraphs: [
            {
                text: 'fraud_preventive_measures_paragraph_1',
                list: [
                    {
                        text: 'fraud_preventive_measures_paragraph_1_list_1',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'fraud_preventive_measures_paragraph_1_list_2',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'fraud_preventive_measures_paragraph_1_list_3',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'fraud_preventive_measures_paragraph_1_list_4',
                        languageToShow: [Language.LT, Language.EN]
                    }
                ],
                languageToShow: [Language.LT, Language.EN]
            },
            {
                text: 'fraud_preventive_measures_paragraph_2',
                list: [
                    {
                        text: 'fraud_preventive_measures_paragraph_2_list_1',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'fraud_preventive_measures_paragraph_2_list_2',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'fraud_preventive_measures_paragraph_2_list_3',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'fraud_preventive_measures_paragraph_2_list_4',
                        languageToShow: [Language.LT, Language.EN]
                    }
                ],
                languageToShow: [Language.LT, Language.EN]
            }
        ],
        languageToShow: [Language.LT, Language.EN]
    },
    {
        heading: 'fraud_important_information_heading',
        paragraphs: [
            {
                text: 'fraud_important_information_paragraph_1',
                languageToShow: [Language.LT, Language.EN]
            },
            {
                text: 'fraud_important_information_paragraph_2',
                languageToShow: [Language.LT, Language.EN]
            },
            {
                text: 'fraud_important_information_paragraph_3',
                languageToShow: [Language.LT, Language.EN]
            }
        ],
        languageToShow: [Language.LT, Language.EN]
    }
]
